import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';

import Modal from 'app/services/modals';
import PrinterStore from 'app/stores/printer';

import CompaniesComponent from 'app/directives/companies.component';

import { PrinterListCtrl } from './ctrls';

import mainTpl from './templates/list.main.html';


@Module({
    name: 'app.admin.printers',
    modules: [
        BaseRoute,
        Modal,
        PrinterStore,
        CompaniesComponent,
    ],
})
@State({
    name: 'r.in.top.admin.printers',
    url: '/printers',
    template: '<div ui-view></div>',
    abstract: '.list',
    data: {
        permissions: {
            only: [
                'main.view_companyprinter',
            ],
        },
    },
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'r.in.top.admin.printers.list',
    url: '?search',
    template: mainTpl,
    controller: PrinterListCtrl,
    ncyBreadcrumb: {
        label: 'Printers',
    },
})

export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/printers/routing.js